import React from "react";
import { useOurApi } from "../../../hooks/useOurApi"
import  Spinner  from "../../Spinner/Spinner"
import MensajeError from '../../Mensajes/MensajeError'

import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@material-ui/core';

const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);
  
  const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const useStyles = makeStyles({
    table: {
      //minWidth: 700,
    },
  });
export default function DetalleTracking({tracking}){
    


 

  function textoOtroIdentificacion(respuestaRealizada)
  {
    return respuestaRealizada.nifPersonaQueResponde +"\n"  +respuestaRealizada.razonSolicalPersona;
   
  }
  function textoEstado(idEstado){
    switch (idEstado) {
      //case 0:          
      //  return 'Sin definir';
      case 1:          
        return 'Solicitada';
      case 2:          
        return 'Aceptada';
      case 3:          
        return 'Rechazada';
      case 4:          
        return 'Expirada';
      case 5:          
        return 'Cancelada';
      case 6:          
        return 'Revocada';
      case 7:
        return 'Caducada';
      case 8:
          return 'Anulada por baja en BD personas';
      case 9:
          return 'Anulada por inicio concurso';
      case 10:
          return 'Anulada por final de concurso';
      case 11:
          return 'Cambio de NIF';
      case 12:
          return 'Generada por absorción';
      default:
        return '-';
    }
  }
  const formateaFechaGuiones = (fechaText) => {
              
    var fechaFormateada = '';
    
    var fecha = new Date(fechaText);
    if (fecha != null && !isNaN(fecha.getTime()) && fecha instanceof Date){
      var fechaSinGMT = new Date(fecha.toUTCString().split(' ').slice(0, 4).join (' '))
      const dia = fechaSinGMT.getDate().toString().padStart(2,'0');
      const mes = (fechaSinGMT.getMonth() + 1).toString().padStart(2,'0');
      const anyo = fechaSinGMT.getFullYear().toString();

      fechaFormateada = dia + '/' + mes + '/' + anyo;
    }
    
    return fechaFormateada;
  }
  
  const classes = useStyles();
  
    //const datosDeContacto={email:data.email,telefono:data.telefono};
  return  <>
    { !tracking &&  <Spinner />}
    {tracking &&  
    <TableContainer component={Paper}>
                        <Table  className={classes.table} size="small" aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                   <StyledTableCell align="center">Identificación</StyledTableCell>
                                    <StyledTableCell align="center">Estado</StyledTableCell>
                                    <StyledTableCell align="center">Fecha</StyledTableCell>                                    
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                 
                                 tracking.map((row) => (
                                    <StyledTableRow>
                                        <StyledTableCell align="center">{textoOtroIdentificacion(row.respuesta)}</StyledTableCell>
                                        <StyledTableCell align="center">{textoEstado(row.estadoTracking)}</StyledTableCell>
                                        <StyledTableCell align="center">{formateaFechaGuiones(row.fechaTracking)}</StyledTableCell>                                        
                                                                           
                                    </StyledTableRow >
                                ))                                
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
        }
    </>
}